import { breakpoints, Button, Dialog, Inline } from '@etg/wings';
import { css, cx, getTextStyles } from '@eti/styles';
import { DangerousHtmlContent } from '@eti/components';
import { useTranslation } from '@eti/providers';
import DialogIllustration from './DialogIllustration';
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const buttonClass = css`
  width: 100%;

  @media (min-width: ${breakpoints._768}) {
    width: auto;
  }
`;
const ReadMoreModal = ({
  content,
  contentAsMarkup,
  modalConfirmLabel,
  onClose,
  productName,
  show,
  title
}) => {
  const {
    t
  } = useTranslation();
  return /*#__PURE__*/_jsxs(Dialog, {
    closeButtonAriaLabel: t('ScreenReader.CloseButtonDialog.AriaLabel.Text'),
    "data-testid": `${productName}-readMoreModal-open`,
    footer: /*#__PURE__*/_jsx(Inline, {
      align: "end",
      children: /*#__PURE__*/_jsx(Button, {
        className: buttonClass,
        "data-testid": `${productName}-readMoreModal-closeButton`,
        onClick: onClose,
        children: modalConfirmLabel
      })
    }),
    illustration: /*#__PURE__*/_jsx(DialogIllustration, {
      productName: productName
    }),
    isOpen: show,
    onDismiss: onClose,
    title: title,
    children: [/*#__PURE__*/_jsx(DangerousHtmlContent, {
      className: cx('etiModal__content', getTextStyles()),
      content: content,
      "data-testid": `${productName}-dialog-content`
    }), contentAsMarkup]
  });
};
export default ReadMoreModal;
//# sourceMappingURL=ProductReadMoreModal.js.map